<template>
    <div class="top-container">
        <div class="model-container">
            <div :class="activeItem==='1'?'model-item model-active':'model-item'" @click="handleActiveChange('1')">成长明细</div>
            <div :class="activeItem==='2'?'model-item model-active':'model-item'" @click="handleActiveChange('2')">师资培训</div>
            <div :class="activeItem==='3'?'model-item model-active':'model-item'" @click="handleActiveChange('3')">教学教研</div>
            <div :class="activeItem==='4'?'model-item model-active':'model-item'" @click="handleActiveChange('4')">教科研</div>
        </div>
        <!-- 成长明细-->
        <el-scrollbar class="second-container" v-if="activeItem==='1'" >
            <div class="bre9e">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 145px)"
                          :data="detailList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column  align="center" label="类型" prop="typeName">
                    </el-table-column>
                    <el-table-column  align="center" label="名称" prop="businessName">
                    </el-table-column>
                    <el-table-column  align="center" width="100" label="相关数量" prop="amount">
                    </el-table-column>
                    <el-table-column fixed="right" width="100" label="操作" align="center">
                        <template #default="scope">
                            <el-button type="primary" size="small" @click="viewDetail(scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-scrollbar>
        <!-- 师资培训-->
        <el-scrollbar class="second-container" v-if="activeItem==='2'" >
            <div class="edu-Info-container" v-if="trainList&&trainList.length>0">
                参与培训数：{{trainInfo.amount}}&nbsp;&nbsp;&nbsp;培训总学时：{{trainInfo.periodCount}}
            </div>

            <el-timeline >
                <el-timeline-item
                  v-for="(item, index) in trainList"
                  :key="index"
                  :color="'#3b62f8'">
                    <div style="font-size: 16px;color: #3b62f8;font-weight: bold;margin-bottom: 20px">{{item.timeTitle}}</div>
                    <div class="edu-item-container" v-for="t in item.list" :key="t">
                        <div class="item-l">
                            <div class="item-1">{{timestampToTime(t.timestamp)}}</div>
                            <div class="item-2">{{t.title}}</div>
                        </div>
                        <div class="item-r">
                            <div class="item-zb" v-if="t.type===0">直播培训</div>
                            <div class="item-lb" v-if="t.type===1">录播培训</div>
                            <div class="item-xc" v-if="t.type===2">现场培训</div>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>

            <div v-if="trainList&&trainList.length===0">
                <data-empty title="暂无数据" />
            </div>
        </el-scrollbar>
        <!-- 教学教研-->
        <el-scrollbar class="second-container" v-if="activeItem==='3'" >
            <div class="edu-Info-container" v-if="studyList&&studyList.length>0">
                参与总数：{{studyInfo.amount}}
            </div>

            <el-timeline >
                <el-timeline-item
                  v-for="(item, index) in studyList"
                  :key="index"
                  :color="'#3b62f8'">
                    <div style="font-size: 16px;color: #3b62f8;font-weight: bold;margin-bottom: 20px">{{item.timeTitle}}</div>
                    <div class="edu-item-container" v-for="t in item.list" :key="t">
                        <div class="item-l">
                            <div class="item-1">{{timestampToTime(t.timestamp)}}</div>
                            <div class="item-2">{{t.title}}</div>
                        </div>
                        <div class="item-r">
                            <div class="item-zb" v-if="t.type===0">个人备课</div>
                            <div class="item-lb" v-if="t.type===1">协同备课</div>
                            <div class="item-xc" v-if="t.type===2">听评课</div>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>

            <div v-if="studyList&&studyList.length===0">
                <data-empty title="暂无数据" />
            </div>
        </el-scrollbar>
        <!-- 教科研-->
        <el-scrollbar class="second-container" v-if="activeItem==='4'" >
            <div class="edu-Info-container" v-if="eduList&&eduList.length>0">
                参与总数：{{eduInfo.amount}}
            </div>

            <el-timeline >
                <el-timeline-item
                  v-for="(item, index) in eduList"
                  :key="index"
                  :color="'#3b62f8'">
                    <div style="font-size: 16px;color: #3b62f8;font-weight: bold;margin-bottom: 20px">{{item.timeTitle}}</div>
                    <div class="edu-item-container" v-for="t in item.list" :key="t">
                        <div class="item-l">
                            <div class="item-1">{{timestampToTime(t.timestamp)}}</div>
                            <div class="item-2">{{t.title}}</div>
                        </div>
                        <div class="item-r">
                            <div class="item-zb" v-if="t.type===0">课题引领</div>
                            <div class="item-lb" v-if="t.type===1">教研赛事</div>
                            <div class="item-xc" v-if="t.type===2">专题活动</div>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>

            <div v-if="eduList&&eduList.length===0">
                <data-empty title="暂无数据" />
            </div>
        </el-scrollbar>

        <el-dialog v-model="isShowDetail" title="成长明细相关数据" width="50%" @close="isShowDetail = !isShowDetail">
            <div class="bre9e">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          :data="businessList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column  align="center" label="名称" prop="title">
                    </el-table-column>
                    <el-table-column  align="center" label="级别" prop="levelName">
                    </el-table-column>
                    <el-table-column  align="center" width="100" label="范围" prop="natureName">
                    </el-table-column>
                    <el-table-column  align="center" width="100" label="角色" prop="roleName">
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import { developDetail,developTrain ,developStudy,developEdu} from "@/api/admin/userCenter"
import DataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "developCenter",
    components: {DataEmpty},
    data() {
        return {
            timestampToTime,
            isShowDetail:false,
            token: this.$storage.get("token"),
            activeItem:'1',
            detailList:[],
            businessList:[],
            trainInfo:{},
            trainList:[],
            studyInfo:{},
            studyList:[],
            eduInfo:{},
            eduList:[],

        };
    },
    created() {
        // 成长明细
        this.getDevelopDetail();
        // 师资培训
        this.getDevelopTrain();
        // 教学教研
        this.getDevelopStudy();
        // 教科研
        this.getDevelopEdu();
    },
    activated() {},
    watch: {},
    methods: {
        handleActiveChange(activeItem){
            this.activeItem = activeItem;
            if (this.activeItem==='1'){
                this.getDevelopDetail()
            }
            if (this.activeItem==='2'){
                this.getDevelopTrain()
            }
        },
        getDevelopDetail(){
            developDetail().then(res => {
                if (res.data.code===1){
                    this.detailList = res.data.data;
                }
            })
        },
        getDevelopTrain(){
            developTrain().then(res => {
                if (res.data.code===1){
                    this.trainInfo = res.data.data;
                    this.trainList = this.trainInfo.list;
                }
            })
        },
        getDevelopEdu(){
            developEdu().then(res => {
                if (res.data.code===1){
                    this.eduInfo = res.data.data;
                    this.eduList = this.eduInfo.list;
                }
            })
        },
        getDevelopStudy(){
            developStudy().then(res => {
                if (res.data.code===1){
                    this.studyInfo = res.data.data;
                    this.studyList = this.studyInfo.list;
                }
            })
        },
        viewDetail(row){
            this.businessList = row.list;
            this.isShowDetail = true;
        }
    }
};
</script>
<style scoped>
.top-container{
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto!important;
}
.second-container{
    width: 100%;
    height: calc(100vh - 140px);
    background-color: #fff;
    box-sizing: border-box;
}
.model-container{
    width: 100%;
    height: 50px;
    display: flex;
    padding-left: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #3b62f8;
    background-color: #fff;
}
.model-item{
    width: auto;
    padding: 0 10px 0 10px;
    height: 28px;
    color: #3b62f8;
    border: 1px solid #3b62f8;
    line-height: 28px;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 6px;
    margin-top: 11px;
    cursor: pointer;
    font-weight: bold;
}
.model-active{
    color: #fff!important;
    border: 1px solid #3b62f8!important;
    background-color: #3b62f8!important;
}
.edu-Info-container{
    width: 100%;
    height: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    color: #3b62f8;
    text-indent: 30px;
    line-height: 30px;
    font-weight: bold;
}
.edu-item-container{
    width: 80%;
    height: 56px;
    margin-top: 10px;
    border: 1px solid #e4e7ed;
    border-radius: 5px;
    padding: 8px 8px 0 8px;
    display: flex;

}
.item-l{
    height: 100%;
    width: calc(100% - 80px);
}
.item-r{
    height: 100%;
    width: 80px;
}
.item-1{
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    color: #767676;
    font-weight: bold;
}
.item-2{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    color: #3b62f8;
    font-weight: bold;
}

.item3{
    width: 80px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    background-color: #3b62f8;
    color: #fff;
    text-align: center;
    border-radius: 5px;
}
.item-zb{
    width: 80px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    background-color: #81b336;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    font-weight: bold;
}
.item-lb{
    width: 80px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    background-color: #ffbf6b;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    font-weight: bold;
}
.item-xc{
    width: 80px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    background-color: #00a173;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    font-weight: bold;
}
</style>